import { Grid, Box, Typography, Button } from '@mui/material';
import { Table, TableRow, TableBody } from '@mui/material';
import { OverviewStyles, OverviewTableCell, OverviewCard } from '../Info';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const LeadInfo = props => {
  const { customerData } = props;
  const classes = OverviewStyles();

  const referenceTimestamp = customerData?.leadInfo?.createdAt;
  const referenceDate = referenceTimestamp
    ? new Date(referenceTimestamp)
        .toLocaleString('en-US', {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true
        })
        .replace(',', ' at')
    : '--';

  return (
    <OverviewCard>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box p={1}>
            <Typography className={classes.headingText} color="primary">
              Lead Info
            </Typography>
            <Table className={classes.noBorderSpaced}>
              <TableBody>
                <TableRow>
                  <OverviewTableCell>
                    <span className={classes.rowHeader}>Referred By</span>
                    <span className={classes.rowText}>
                      {customerData?.leadInfo?.referrer || 'N/A'}
                    </span>
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    <span className={classes.rowHeader}>Campaign</span>
                    <span className={classes.rowText}>
                      {customerData?.leadInfo?.leadCampaign || 'N/A'}
                    </span>
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    <span className={classes.rowHeader}>Source</span>
                    <span className={classes.rowText}>
                      {customerData?.leadInfo?.origin || 'N/A'}
                    </span>
                  </OverviewTableCell>
                </TableRow>
                <TableRow>
                  <OverviewTableCell>
                    <span className={classes.rowHeader}>Date</span>
                    <span className={classes.rowText}>{referenceDate}</span>
                  </OverviewTableCell>
                </TableRow>
              </TableBody>
            </Table>
            {customerData?.leadInfo?.link && (
              <Button
                variant="outlined"
                color="primary"
                sx={{ mt: 1 }}
                onClick={() => {
                  window.open(customerData?.leadInfo?.link, '_blank');
                }}
              >
                View in Referrizer&nbsp;&nbsp;
                <ArrowOutwardIcon fontSize="small" />
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    </OverviewCard>
  );
};

export default LeadInfo;
